import TopBar from "./TopBar";
import MainNav from "./MainNav";

const StickyHeader = () => {
  return (
    <div className="sticky top-0 z-50">
      <TopBar />
      <MainNav />
    </div>
  );
};

export default StickyHeader;
